export const SHIFT_COLOR_COUNT = 6;
export const WEEK_DAY_KEYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
export const DEFAULT_SHIFT_DAYS = ["MON", "TUE", "WED", "THU", "FRI"];

export function shiftCode(name, allTemplates) {
  if (!name) return "?";
  const trimmed = name.trim();
  const words = trimmed.split(/\s+/);
  const last = words[words.length - 1];
  const single = last[0].toUpperCase();

  if (allTemplates && allTemplates.length > 1) {
    const allCodes = allTemplates.map((t) => {
      const w = t.name.trim().split(/\s+/);
      return w[w.length - 1][0].toUpperCase();
    });
    const collides = allCodes.filter((c) => c === single).length > 1;
    if (collides) return name.trim().slice(0, 2).toUpperCase();
  }
  return single;
}

export function shiftMatchesSchedule(shift, schedule) {
  if (!shift || !schedule) return false;
  return (
    shift.workStartTime === schedule.workStartTime &&
    shift.workEndTime === schedule.workEndTime
  );
}

export function resolveShiftForDay(dayData, shiftTemplates) {
  if (!dayData || !Array.isArray(shiftTemplates) || dayData.type !== "WORKING") return null;
  if (dayData.scheduleSource !== "USER") return null;
  return (
    shiftTemplates.find(
      (s) => s.workStartTime === dayData.workStartTime && s.workEndTime === dayData.workEndTime,
    ) || null
  );
}

export function buildShiftColorMap(shiftTemplates) {
  const map = new Map();
  shiftTemplates.forEach((s, i) => map.set(s.id, i % SHIFT_COLOR_COUNT));
  return map;
}

export function getCellDisplay(dayData, shiftTemplates) {
  if (!dayData) return { code: "", colorIndex: -1, cls: "roster-cell--empty", shift: null };

  if (dayData.type === "HOLIDAY") {
    return { code: "✕", colorIndex: -1, cls: "roster-cell--holiday", tooltip: dayData.holidayName, shift: null };
  }

  if (dayData.type === "WEEKLY_OFF") {
    return { code: "–", colorIndex: -1, cls: "roster-cell--wo", shift: null };
  }

  if (dayData.source === "USER_OVERRIDE") {
    if (dayData.type === "HALF_DAY") {
      return { code: "½", colorIndex: -1, cls: "roster-cell--half", shift: null };
    }
    if (dayData.type === "WORKING") {
      return { code: "W", colorIndex: -1, cls: "roster-cell--working", shift: null };
    }
    return { code: "L", colorIndex: -1, cls: "roster-cell--leave", shift: null };
  }

  const shift = resolveShiftForDay(dayData, shiftTemplates);
  if (shift) {
    const colorIndex = shiftTemplates.indexOf(shift) % SHIFT_COLOR_COUNT;
    return {
      code: shiftCode(shift.name, shiftTemplates),
      colorIndex,
      cls: `roster-cell--shift range-color-${colorIndex}`,
      shift,
    };
  }

  if (dayData.type === "WORKING") {
    return { code: "W", colorIndex: -1, cls: "roster-cell--working", shift: null };
  }

  return { code: "", colorIndex: -1, cls: "", shift: null };
}

export function toDateStr(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function parseDateStr(str) {
  if (!str) return null;
  const [y, m, d] = str.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function monthDates(year, month) {
  const count = new Date(year, month, 0).getDate();
  const dates = [];
  for (let d = 1; d <= count; d++) {
    dates.push(toDateStr(new Date(year, month - 1, d)));
  }
  return dates;
}

// Group consecutive same-shift days into ranges for batched API calls
export function groupShiftRanges(draftForUser) {
  const dates = Object.keys(draftForUser).sort();
  const ranges = [];
  let i = 0;
  while (i < dates.length) {
    const cell = draftForUser[dates[i]];
    if (cell.type !== "shift" || !cell.shift) { i++; continue; }

    let j = i + 1;
    while (j < dates.length) {
      const prev = parseDateStr(dates[j - 1]);
      const next = parseDateStr(dates[j]);
      const consecutive = next && prev && next.getTime() - prev.getTime() === 86400000;
      if (!consecutive || draftForUser[dates[j]].shiftId !== cell.shiftId) break;
      j++;
    }
    ranges.push({ start: dates[i], end: dates[j - 1], shift: cell.shift });
    i = j;
  }
  return ranges;
}
